import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { DateSelector } from '@/modules/home';
import { useAuth } from '@/shared/hooks/context/auth';
import { useStore } from '@/shared/hooks/context/createGenericContext';

const Header = (): ReactElement => {
  const { t } = useTranslation('common');
  const { user } = useAuth();
  const [selectedAsset] = useStore((store) => store?.asset);

  return (
    <section className='z-10 flex items-center justify-between bg-background-neutral-100'>
      <div className='flex flex-col gap-16'>
        {/* TODO: use roboto */}
        <div className='flex flex-col gap-2 leading-none'>
          <h1 className='text-30 font-semi-bold capitalize text-text-default'>
            {t('hi')}, {user?.firstName} 👋
          </h1>
          <span className='text-grey-600'>
            <span> {t('welcome-to')}</span> {selectedAsset?.name}
          </span>
        </div>
        <DateSelector />
      </div>
      {/* <CropsSelector /> */}
    </section>
  );
};
export { Header };
